import styled from 'styled-components';
import { palettePrimaryMain, palettePrimaryContrast } from '../../../assets/variables';
export const Wrapper = styled.div`
  overflow: hidden;
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;

  button {
    height: 50px;
    width: 50px;
    border: none;
    cursor: pointer;
    padding: 0;
    &:hover {
      background-color: #31635a;
    }
  }
  .page-header {
    position: fixed;
    width: calc(100% - 9px);
    background-color: ${palettePrimaryMain};
    color: #fafbfc;
    padding-left: 10px;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-shadow: 0 4px 8px -4px black;
    justify-content: space-between;
    .download {
      color: ${palettePrimaryContrast};
      text-decoration: none;
    }
  }

  .page-content {
    display: flex;
    flex: 1 1 0;
    height: calc(100vh - 50px);

    .aside {
      flex-shrink: 0;
      height: 100%;
    }
    .main {
      width: 100%;
      flex-shrink: 1;
      overflow-y: scroll;
      padding-top: 10px;
      .image-container {
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
      }

      .content-container {
        margin: 0 auto;
        max-width: 900px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 40px 5px;
        img {
          margin-bottom: 10px;
          width: 90%;
        }
      }
    }
  }
`;
